<template>
  <div class="main">
    <a-card style="border-radius: 20px;" :bordered="false">
      <div class="actions">
        <h3 style="font-size: 28px; line-height: 45px">Warehouse</h3>
      </div>
      <!-- create modal -->
      <a-modal class="modalStyle" :visible="showAddDistroCenter" :footer="null"
        @cancel="showAddDistroCenter = !showAddDistroCenter">
        <CreateDistroCenterModal />
      </a-modal>
      <!-- create modal -->
      <div>
        <div class="card-container">
          <a-tabs type="card">
            <a-tab-pane key="1">
              <span slot="tab">
                Central Stores
              </span>
              <div class="requestActions"></div>
              <WarehouseComponent />
            </a-tab-pane>
            <a-tab-pane key="2">
              <span slot="tab">
                Subs Stores
              </span>
              <div class="requestActions">
                <a-button @click="showAddDistroCenter = !showAddDistroCenter" style="
                  height: 38px;
                  border-raduis: 5px;
                  background: #418a49;
                  float: right;
                  color: #fff;
                " icon="plus">
                  Add New Sub
                </a-button>
              </div>
              <AllDistroCenterTable :distroCenters="distroCenters" />
            </a-tab-pane>
            <a-tab-pane key="3">
              <span slot="tab">
                Virtual Stores
              </span>
              <VirtualSubsTable :distroCenters="virtualSubs" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import XLSX from "xlsx";
import moment from "moment";
import { NotificationMixins } from "@/mixins/NotificationMixins";
import WarehouseComponent from "@/components/warehouse/WareHouse";

export default {
  name: "DistroCenters",
  components: {
    WarehouseComponent,
    AllDistroCenterTable: () =>
      import("@/components/locations/tables/AllDistroCenterTable"),
    VirtualSubsTable: () =>
      import("@/components/locations/tables/VirtualSubsTable"),
    // NewDistroCentersTable: () =>
    //   import("@/components/locations/tables/NewDistroCenterTable"),
    CreateDistroCenterModal: () =>
      import("@/components/locations/modals/CreateDistroCenter"),
  },
  mixins: [NotificationMixins],
  data: () => ({
    showAddDistroCenter: false,
    virtualSubs: [],
  }),
  computed: {
    distroCenters() {
      return this.$store.getters["distroCenter/GetDistroCenters"];
    },
    newDistros() {
      return this.$store.getters["distroCenter/GetNewDistroCenters"];
    },
  },
  methods: {
    handleExport() {
      const dataToExport = [
        ["Center ID", "Centre Name", "Centre Address", "Created Date"],
      ];
      this.distroCenters.data.forEach((center) => {
        dataToExport.push([
          center.id,
          center.name,
          center.address,
          (center.createdAt = moment(center.createdAt).format("DD-MMM-YYYY")),
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-All-Distribution-Centres-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
  },
  watch: {
    distroCenters: function (newDistroCenters) {
      let virtuals = [];
      let distros = [];
      newDistroCenters.data.forEach((center) => {
        if (center.type) {
          virtuals.push(center);
        } else if (center.type === 0) {
          distros.push(center);
        }
      });
      this.virtualSubs = virtuals;
      this.distroCenters.data = distros;
    },
  },
  mounted() {
    this.$store.dispatch("distroCenter/FetchDistroCenters", { limit: -1 });
  },
};
</script>

<style scoped>
/* Start Style for Tab  */
.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container
  >>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.card-container >>> .ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.card-container >>> .ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.card-container >>> .ant-tabs-card > .ant-tabs-bar {
  border: none;
}

.card-container >>> .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  height: 40px;
  color: #111827;
  background: transparent;
  border-radius: 8px;
  max-width: 18%;
  margin-right: 12px;
}


.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #fff;
  background: #418a49;
  border-bottom: none;
  border-radius: 8px;
  max-width: 18%;
}

/* End Style for Tab  */
</style>